import { render, staticRenderFns } from "./DoQuestionAppraise.vue?vue&type=template&id=978f5370&scoped=true&"
import script from "./DoQuestionAppraise.vue?vue&type=script&lang=js&"
export * from "./DoQuestionAppraise.vue?vue&type=script&lang=js&"
import style0 from "./DoQuestionAppraise.vue?vue&type=style&index=0&id=978f5370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978f5370",
  null
  
)

component.options.__file = "DoQuestionAppraise.vue"
export default component.exports